/**
 * El scroll de la página del Admin. Por lo general desplaza la ventana; en el celular, con una barra fija abajo (C21), el
 * que desplaza es `main#main`, que termina sobre la barra (C27: «el scroll termina sobre ella, nada asoma debajo»;
 * admin.css). Estas dos ayudas sirven en los dos casos.
 */

/** `main#main` cuando es él quien desplaza la página (celular con barra fija); si no, null (desplaza la ventana). */
export function pageScroller(): HTMLElement | null {
  const main = document.getElementById("main");
  if (!main) return null;
  return /auto|scroll/.test(getComputedStyle(main).overflowY) ? main : null;
}

/** Vuelve al principio de la página, sea cual sea el que desplaza. */
export function scrollPageTop() {
  window.scrollTo(0, 0);
  const main = document.getElementById("main");
  if (main) main.scrollTop = 0;
}
